module.exports = __webpack_public_path__ + "img/icon_sense_white.9e9e7786.svg";